import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Plus } from "../../assets/newImages/icons/plus.svg";
import BackendInfiniteScroll from "../../components/BackendInfiniteScroll/BackendInfiniteScroll";
import { Button } from "../../components/Button/index";
import ComponentInfiniteScroll from "../../components/ComponentInfiniteScroll/ComponentInfiniteScroll";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { Filtros } from "../../components/Filtros/Filtros";
import { Input } from "../../components/Input/index";
import Loading from "../../components/Loading/Loading";
import Modal from "../../components/Modal/Modal";
import ProdutoComSkeleton from "../../components/Produto/index";
import { Select } from "../../components/Select/index";
import { SelectListagem } from "../../components/Select/SelectListagem/index";
import SkeletonProdutos from "../../components/Skeletons/SkeletonProdutos/SkeletonProdutos";
import { ConfiguracoesProvider } from "../../contexts/Configuracoes/ConfiguracoesProvider";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { IntegracaoProvider } from "../../contexts/Integracao/IntegracaoProvider";
import { ProdutosContext } from "../../contexts/Produtos/ProdutosContext";
import { ScrollDirectionContext } from "../../contexts/ScrollDirection/ScrollDirectionContext";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { configuracoesApi } from "../../hooks/configuracoesApi";
import ImportarPorErp from "./ImportarPorErp/ImportarPorErp";
import "./styles";
import { MeusProdutosView, ModalNovoProduto } from "./styles";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { PERMISSOES } from "../../services/Consts";
import LockedIcon from "../../components/LockedIcon/LockedIcon";
import { produtosApi } from "../../hooks/produtosApi";

interface ProdutosProps {}

const Produtos: React.FC<ProdutosProps> = ({}) => {
  const { theme } = useTheme();
  const [modalErp, setModalErp] = useState(false);
  const scrollDir = useContext(ScrollDirectionContext).direction;
  const [cadastroBloqueado, setCadastroBloqueado] = useState(false);

  const { erp_empresa } = useContext(EmpresaContext);

  const ConfiguracoesApi = configuracoesApi();

  const [config_integracao, setConfigIntegracao] = useState({
    permitir_produtos: false,
    permitir_imagens: false,
    permitir_observacoes: false,
  });

  const { permissoesPlanos, permissoesUsuario } = useContext(AuthContext);
  // Cadastro reusa o flag central permitir_produtos; dobra a permissão (visualizar-only não cadastra).
  const temPilulaProduto =
    permissoesUsuario?.includes(PERMISSOES.PRODUTOS_VISUALIZAR) ||
    permissoesUsuario?.includes(PERMISSOES.PRODUTOS_CRIAR_EDITAR) ||
    permissoesUsuario?.includes(PERMISSOES.PRODUTOS_EXCLUIR);
  const podeCriarEditarProduto =
    !temPilulaProduto || permissoesUsuario?.includes(PERMISSOES.PRODUTOS_CRIAR_EDITAR);
  const cadastroDesabilitado = cadastroBloqueado || !podeCriarEditarProduto;

  useEffect(() => {
    const init = async () => {
      const res = await ConfiguracoesApi.verifica_config_integracoes();
      setConfigIntegracao({
        permitir_produtos: res.upload_produtos,
        permitir_imagens: res.upload_imagens,
        permitir_observacoes: res.upload_configurar_observacao,
      });

      produtosApi()
        .verificarLimiteProdutos()
        .then((res) => {
          setCadastroBloqueado(false);
        })
        .catch((err) => {
          setCadastroBloqueado(true);
        });
    };

    init();
  }, []);

  const optionsCadastro = [
    {
      value: "individualmente",
      name: "Individualmente",
    },
    {
      value: "em_massa",
      name: "Em massa",
      icon: !permissoesPlanos[
        "IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"
      ]?.permitido && <LockedIcon mensagem="Recurso disponível a partir do plano Essencial" className="blocked" />,
      disabled:
        !permissoesPlanos[
          "IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"
        ]?.permitido,
    },
    {
      value: "erp",
      name: "ERP",
      icon: !permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido && (
        <LockedIcon mensagem="Recurso disponível a partir do plano Essencial"/>
      ),
      disabled: !permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido,
    },
  ];

  const [seletorMobile, setSeletorMobile] = useState(false);

  const [cadastroSelecionado, setCadastroSelecionado] = useState(() => {
    const cadastro = localStorage.getItem("cadastro_prod");
    if (cadastro) {
      return cadastro;
    }
    return "individualmente";
  });

  const navigate = useNavigate();

  const [semCadastroSelecionado, setSemCadastroSelecionado] = useState(false);

  function cadastrarNovo() {
    if (cadastroSelecionado == "individualmente") {
      navigate("/painel/produtos/produto/0");
    } else if (cadastroSelecionado == "em_massa") {
      navigate("/painel/produtos/importar-produtos");
    } else if (cadastroSelecionado == "erp") {
      setModalErp(true);
    }
  }

  const {
    loading,
    setLoading,
    newProductModal,
    produtos,
    setNewProductModal,
    produtosFiltrados,
    filtros,
    setFiltros,
    filtroPesquisaAux,
    setFiltroPesquisaAux,
    categorias,
    optionsAtivos,
    optionsEstoque,
    optionsTags,
    hasMore,
    fetchMore,
    loadingMore,
  } = useContext(ProdutosContext);

  // Estados auxiliares para os filtros de Ativos e Estoque
  const [filtroAtivosAux, setFiltroAtivosAux] = useState(filtros.filtroAtivos);
  const [filtroEstoqueAux, setFiltroEstoqueAux] = useState(filtros.filtroEstoque);

  // Sincroniza estados auxiliares quando filtros mudam
  useEffect(() => {
    setFiltroAtivosAux(filtros.filtroAtivos);
    setFiltroEstoqueAux(filtros.filtroEstoque);
  }, [filtros.filtroAtivos, filtros.filtroEstoque]);

  // Conta quantos filtros estão ativos (valor padrão de filtroAtivos é "1")
  const activeFiltersCount =
    (filtros.filtroAtivos !== "1" ? 1 : 0) +
    (filtros.filtroEstoque !== "todos" ? 1 : 0);

  const handleSearchDebounce = useCallback((newValue: string) => {
    setFiltros(prev => ({ ...prev, filtroPesquisa: newValue }));
  }, []);

  useEffect(() => {
    localStorage.getItem("cadastro_prod") == null
      ? setSemCadastroSelecionado(true)
      : setSemCadastroSelecionado(false);
  }, [semCadastroSelecionado]);

  const scrollRestored = useRef(false);
  const scrollCancelled = useRef(false);

  useEffect(() => {
    if (!loading && produtosFiltrados.length > 0 && !scrollRestored.current) {
      const scrollPosition = sessionStorage.getItem("produtos_scroll_position");
      if (scrollPosition) {
        scrollRestored.current = true;
        scrollCancelled.current = false;
        sessionStorage.removeItem("produtos_scroll_position");
        const targetPosition = parseInt(scrollPosition);

        const cancelScroll = () => {
          scrollCancelled.current = true;
          window.scrollTo(window.scrollX, window.scrollY);
        };

        window.addEventListener("wheel", cancelScroll);
        window.addEventListener("touchstart", cancelScroll);
        window.addEventListener("mousedown", cancelScroll);

        const cleanup = () => {
          window.removeEventListener("wheel", cancelScroll);
          window.removeEventListener("touchstart", cancelScroll);
          window.removeEventListener("mousedown", cancelScroll);
        };

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!scrollCancelled.current) {
              window.scrollTo({ top: targetPosition, behavior: "smooth" });
              setTimeout(cleanup, 1000);
            } else {
              cleanup();
            }
          });
        });
      }
    }
  }, [loading, produtosFiltrados]);

  const ChildrenNewProduct = (
    <ModalNovoProduto theme={theme}>
      <div className="titulo">
        Como gostaria de
        <br />
        <span>adicionar seus produtos?</span>
        <div className="link">
          <Link
            to={"/painel/produtos/produto/0"}
            className="center"
            onClick={() => {
              localStorage.setItem("cadastro_prod", "individualmente");
            }}
          >
            Adicionar individualmente
          </Link>
        </div>
        <div className="link">
          {permissoesPlanos[
            "IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"
          ]?.permitido ? (
            <Link
              to={"/painel/produtos/importar-produtos"}
              className="center"
              onClick={() => {
                localStorage.setItem("cadastro_prod", "em_massa");
              }}
            >
              Adicionar produtos em massa
            </Link>
          ) : (
            <div className="center locked">
              Adicionar produtos em massa
              <LockedIcon mensagem="Recurso disponível a partir do plano Essencial." />
            </div>
          )}
        </div>
        <div className="link">
          {permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido ? (
            <Link
              to={"#"}
              className="center"
              onClick={(e) => {
                e.preventDefault();
                localStorage.setItem("cadastro_prod", "erp");
                setModalErp(true);
                setNewProductModal(false);
              }}
            >
              Adicionar através do ERP
            </Link>
          ) : (
            <div className="center locked">
              Adicionar através do ERP
              <LockedIcon mensagem="Recurso disponível a partir do plano Essencial."/>
            </div>
          )}
        </div>
      </div>
    </ModalNovoProduto>
  );

  return (
    <>
      <Modal
        backdrop={"static"}
        isOpen={modalErp}
        setModal={setModalErp}
        width={"auto"}
      >
        <ConfiguracoesProvider>
          <IntegracaoProvider>
            <ImportarPorErp onClose={() => setModalErp(!modalErp)} />
          </IntegracaoProvider>
        </ConfiguracoesProvider>
      </Modal>
      <MeusProdutosView theme={theme}>
        <div className="grid-header">
          <div className="input pesquisa">
            <Input
              type={"text"}
              icone="icons/search.svg"
              placeholder={"Pesquisar por nome do produto, descrição ou SKU"}
              value={filtroPesquisaAux}
              onChange={(newValue) => {
                newValue === filtros.filtroPesquisa
                  ? setLoading(false)
                  : setLoading(true);
                setFiltroPesquisaAux(newValue);
              }}
              onDebounce={handleSearchDebounce}
              debounceTime={500}
            />
          </div>
          <div className="filtro">
            <Filtros
              onAplicar={() => {
                setFiltros({
                  ...filtros,
                  filtroAtivos: filtroAtivosAux,
                  filtroEstoque: filtroEstoqueAux,
                });
              }}
              onCancelar={() => {
                setFiltroAtivosAux(filtros.filtroAtivos);
                setFiltroEstoqueAux(filtros.filtroEstoque);
              }}
              onReset={() => {
                setFiltroAtivosAux("1");
                setFiltroEstoqueAux("todos");
                setFiltros({
                  ...filtros,
                  filtroAtivos: "1",
                  filtroEstoque: "todos",
                });
              }}
              activeFiltersCount={activeFiltersCount}
            >
              <div className="containerSelects">
                <Select
                  options={optionsAtivos}
                  value={filtroAtivosAux}
                  label="Situação"
                  onChange={(newValue) => setFiltroAtivosAux(newValue)}
                />
                <Select
                  options={optionsEstoque.filter(opt => opt.value !== "personalizado")}
                  value={filtroEstoqueAux}
                  label="Estoque"
                  onChange={(newValue) => setFiltroEstoqueAux(newValue)}
                />
              </div>
            </Filtros>
          </div>
          <div className="select categorias">
            <Select
              options={categorias}
              value={filtros.filtroCategoria}
              onChange={(newValue) => {
                setFiltros({ ...filtros, filtroCategoria: newValue });
              }}
            />
          </div>
          <div className="select tags">
            <Select
              options={optionsTags}
              value={filtros.filtroTag}
              onChange={(newValue) => {
                setFiltros({ ...filtros, filtroTag: newValue });
              }}
            />
          </div>
          <div className="botoes">
            {erp_empresa && (
              <Link className="botao" to={"informacoes-erp"}>
                <div className="botao fonteTexto">
                  <Button title="Informações ERP"></Button>
                </div>
              </Link>
            )}
            {!config_integracao.permitir_produtos &&
              config_integracao.permitir_imagens && (
                <Link
                  className="botao"
                  to={"/painel/produtos/importar-imagens"}
                >
                  <div className="botao">
                    <Button title="Importar Imagens"></Button>
                  </div>
                </Link>
              )}
          </div>
        </div>
        <div className="produtos">
          {config_integracao.permitir_produtos ? (
            <>
              <div
                className={`center hideMobile ${
                  semCadastroSelecionado ? "inativo" : ""
                }`}
              >
                <div
                  className="adicionar_produto"
                  onClick={() => {
                    if(cadastroDesabilitado) return;
                    if (semCadastroSelecionado) {
                      setNewProductModal(true);
                    } else {
                      cadastrarNovo();
                    }
                  }}
                >
                  <div className="pai">
                    {cadastroDesabilitado ? (
                      <LockedIcon mensagem={!podeCriarEditarProduto ? "Você não tem permissão para cadastrar produtos" : "Você atingiu o limite de produtos para o seu plano, faça upgrade"} className="locked" width="8rem" redirect={false}/>
                    ) : (
                      <Plus className="plus" />
                    )}
                  </div>
                </div>
                <div className="cadastro">
                  <div className="texto fonteRotulos">Cadastro</div>
                  <div className="select fonteTexto">
                    <SelectListagem
                      options={optionsCadastro}
                      onChange={(newValue) => {
                        localStorage.setItem("cadastro_prod", newValue);
                        setCadastroSelecionado(newValue);
                      }}
                      value={cadastroSelecionado}
                      cores={"white"}
                      disabled={semCadastroSelecionado}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`options-mobile ${
                  seletorMobile && scrollDir === "up" ? "ativo" : ""
                } hideDesktop`}
              >
                <div
                  className={`fonteTexto option primeiro ${
                    cadastroSelecionado == "individualmente" ? "ativo" : ""
                  }`}
                  onClick={() => {
                    localStorage.setItem("cadastro_prod", "individualmente");
                    setCadastroSelecionado("individualmente");
                    setSeletorMobile(false);
                  }}
                >
                  Adicionar individualmente
                </div>
                <div
                  className={`fonteTexto option ${
                    cadastroSelecionado == "em_massa" ? "ativo" : ""
                  }`}
                  onClick={() => {
                    if (!permissoesPlanos["IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"]?.permitido) return;
                    localStorage.setItem("cadastro_prod", "em_massa");
                    setCadastroSelecionado("em_massa");
                    setSeletorMobile(false);
                  }}
                >
                  Adicionar produtos em massa
                  {!permissoesPlanos["IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"]?.permitido && (
                    <LockedIcon mensagem="Recurso disponível a partir do plano Essencial." />
                  )}
                </div>
                <div
                  className={`fonteTexto option ultimo ${
                    cadastroSelecionado == "erp" ? "ativo" : ""
                  }`}
                  onClick={() => {
                    if (!permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido) return;
                    localStorage.setItem("cadastro_prod", "erp");
                    setCadastroSelecionado("erp");
                    setSeletorMobile(false);
                  }}
                >
                  Adicionar através do ERP
                  {!permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido && (
                    <LockedIcon mensagem="Recurso disponível a partir do plano Essencial." />
                  )}
                </div>
              </div>
              <FloatingButton
                subButton={true}
                onClickSubButton={() => {
                  setSeletorMobile(!seletorMobile);
                }}
                disabled={cadastroDesabilitado}
                className="hideDesktop"
                onClick={() => {
                  if (semCadastroSelecionado) {
                    setNewProductModal(true);
                  } else {
                    cadastrarNovo();
                  }
                }}
              />
            </>
          ) : null}

          {loading ? (
            <SkeletonProdutos />
          ) : (
            <>
              {produtosFiltrados.length > 0 && (
                <BackendInfiniteScroll
                  next={fetchMore}
                  hasMore={hasMore}
                  loader={<Loading relative />}
                >
                  {produtosFiltrados.map((produto, index) => (
                    <ComponentInfiniteScroll
                      className="produto-container"
                      key={produto.id}
                    >
                      <Link
                        to={`/painel/produtos/produto/${produto.id}`}
                        onClick={() => {
                          sessionStorage.setItem("produtos_scroll_position", window.scrollY.toString());
                        }}
                      >
                        <ProdutoComSkeleton produto={produto} />
                      </Link>
                    </ComponentInfiniteScroll>
                  ))}
                </BackendInfiniteScroll>
              )}
            </>
          )}
          {!loading &&
            !loadingMore &&
            produtosFiltrados.length === 0 && (
              <>
                <div className="mensagem">
                  <div className="texto-titulo fonteSubtitulo">
                    <div>Nenhum resultado encontrado para sua busca.</div>
                  </div>
                  <div className="texto-subtitulo fonteRotulos">
                    <div>Tente novamente com uma busca diferente!</div>
                  </div>
                </div>
              </>
            )}
        </div>
      </MeusProdutosView>
      <Modal
        isOpen={newProductModal}
        setModal={setNewProductModal}
        children={ChildrenNewProduct}
        width="100rem"
        maxWidth="98vw"
        align="center"
        backdrop="static"
        justify="center"
        animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
        margin="0rem 2rem 0rem 2rem"
      />
    </>
  );
};

export default Produtos;
